module.exports = __webpack_public_path__ + "img/Calendar_Xsmall_Button-inactive.db0d90ec.svg";